// import React from "react";
// import NavItem from "./NavItem";

// const NavList = ({ navList, className, ...p }) => {
//   return (
//     <ul className={className}>
//       {navList.map((item, index) => (
//         <NavItem item={item} key={index} {...p} />
//       ))}
//     </ul>
//   );
// };

// export default NavList;

// src/components/menus/NavList.jsx
import React from "react";
import NavItem from "./NavItem";

const NavList = ({ navList = [], className = "", ...p }) => {
  return (
    <ul className={className}>
      {navList.map((item, index) => (
        <NavItem item={item} key={item.id ?? index} {...p} />
      ))}
    </ul>
  );
};

export default NavList;
